import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { observer } from 'mobx-react';
import { IconButton } from 'ksnm-common-ui/lib/IconButton';

import { RoutePath } from '@components/AppRouter/constants';
import { NEW_ENTITY_ID } from '@components/AppRouter/hooks/constants';
import { usePermission } from '@src/utils/hooks/usePermission';
import { useToggleFullSize } from '@src/utils/hooks/useToggleFullSize';
import { confirmDialogStore } from '@stores/confirmDialog';
import { constantStore } from '@stores/constantStore';
import { reportVersionsStore } from '@stores/dictionaryStores/reportVersion/reportVersionsStore';
import type { ReportVersionDtoDefId } from '@stores/dictionaryStores/reportVersion/reportVersionsStore';

import { columns } from '../columns';

const { TABLE_NAMES } = constantStore;

export const ActionButton = observer(({ update }: { update: () => void }) => {
  const { push } = useHistory();
  const { groupDelete, fullSize, toggleFullSize, checked, setChecked } = reportVersionsStore;
  const { open: openConfirmDialog } = confirmDialogStore;

  const permission = usePermission('CmReportVersion');

  const onToggleFullSize = useToggleFullSize({
    tableName: TABLE_NAMES.DICTIONARY_REPORT_VERSION,
    toggle: toggleFullSize,
    columns,
    fullSize,
    update,
  });

  const onCreate = useCallback(() => {
    push(`${RoutePath.DICTIONARY_REPORT_VERSION}/${NEW_ENTITY_ID}`);
  }, [push]);

  const onEdit = useCallback(() => {
    push(`${RoutePath.DICTIONARY_REPORT_VERSION}/${checked[0]?.code}`);
  }, [checked, push]);

  const onDelete = useCallback(() => {
    openConfirmDialog({
      text: `Удалить выбранные элементы (${checked.length})?`,
      onOk: () => {
        groupDelete(checked as ReportVersionDtoDefId[]).then(() => {
          setChecked([]);
          update();
        });
      },
    });
  }, [checked, groupDelete, openConfirmDialog, setChecked, update]);

  return (
    <>
      {permission.CREATE && <IconButton onClick={onCreate} iconName="add" title="Добавить" />}
      {permission.UPDATE && (
        <IconButton
          onClick={onEdit}
          disabled={!(checked.length == 1 && checked[0]?.regulated === false)}
          iconName="edit"
          title="Редактировать"
        />
      )}
      {permission.DELETE && (
        <IconButton
          onClick={onDelete}
          disabled={checked.length === 0 || !checked.every((el) => el.regulated === false)}
          iconName="delete"
          title="Удалить"
        />
      )}
      <IconButton onClick={onToggleFullSize} iconName={fullSize ? 'fullScreenOpen' : 'fullScreenClose'} />
    </>
  );
});
